import React from 'react'
import styles from './ProgressRing.module.scss'

const ProgressRing = ({
    progress = 0.85,
    value,
    label,
    size = 130,
}: {
    progress?: number
    value?: React.ReactNode
    label?: React.ReactNode
    size?: number
}) => {
    const arc = `${Math.min(Math.max(progress, 0), 1) * 360}deg`
    const ringStyle: React.CSSProperties & { '--ring-size': string; '--arc': string } = {
        '--ring-size': `${size}px`,
        '--arc': arc,
    }

    return (
        <div
            className={styles.ring}
            style={ringStyle}
        >
            <div className={styles.track} />
            <div className={styles.fill} />
            <div className={styles.inner}>
                {value != null && <span className={styles.value}>{value}</span>}
                {label != null && <span className={styles.label}>{label}</span>}
            </div>
        </div>
    )
}

export default ProgressRing

/*
  Usage:
  <ProgressRing progress={0.85} value="12" label="days left" />
*/
